import React from 'react';
import { IconProps } from '.';

const SvgBoxSearch = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M22 2v9h-1.5V3.5H15V11H9V3.5H3.5v17H11V22H2V2h20Zm-8.5 1.5h-3v6h3v-6Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M17.5 21c.834 0 1.608-.255 2.248-.691l2.722 2.721 1.06-1.06-2.721-2.722A4 4 0 1 0 17.5 21Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxSearch;
